import { render, staticRenderFns } from "./ProductIntegration.vue?vue&type=template&id=0bf80694"
import script from "./ProductIntegration.vue?vue&type=script&lang=js"
export * from "./ProductIntegration.vue?vue&type=script&lang=js"
import style0 from "./ProductIntegration.vue?vue&type=style&index=0&id=0bf80694&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports